module.exports = __webpack_public_path__ + "img/hero-still_jp.7b46fe5.jpg";